import { render, staticRenderFns } from "./addProcert.vue?vue&type=template&id=567722dd&scoped=true&"
import script from "./addProcert.vue?vue&type=script&lang=js&"
export * from "./addProcert.vue?vue&type=script&lang=js&"
import style0 from "./addProcert.vue?vue&type=style&index=0&id=567722dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567722dd",
  null
  
)

export default component.exports